import 'whatwg-fetch';
import { history } from '../../router/history';
import {
    logoutAction,
    add_msg,
    setUserTokenAction
} from '../../actions'
import SystemModal from '../SystemModal/SystemModal'
import fetchConfig from "../fetchConfig";
import fetchExtend from '../fetchExtend'

const canFillApplication = (studentList) => {
    const status = studentList && studentList.new_report_status;
    return status === true || status === 'true' || status === 1 || status === '1';
};

export default {
    login: (dispatch, login_id, password) => {
        SystemModal.showMsg(dispatch, '登入中...')
        let formData = new FormData();
        formData.append("login_id", login_id);
        formData.append("password", password);

        let myHeaders = new Headers({
            'Access-Control-Allow-Origin': '*',
        });
        fetch(API_SERVER + '/api/sessions.json', {
            'credentials': 'same-origin',
            method: 'POST',
            headers: myHeaders,
            body: formData

        }).then(fetchExtend.checkStatus)
            .then(fetchExtend.parseJSON)
            .then((data) => {
                sessionStorage.setItem('student_token', data.token)
                dispatch(setUserTokenAction(data.token))
                return fetch(API_SERVER + '/api/student_lists/0.json', {
                    credentials: 'same-origin',
                    method: 'GET',
                    headers: new fetchConfig().fetchConfigHeaders()
                })
                    .then(fetchExtend.checkStatus)
                    .then(fetchExtend.parseJSON)
                    .then((studentList) => {
                        SystemModal.closeMsg(dispatch)
                        if (!canFillApplication(studentList)) {
                            sessionStorage.removeItem('student_token');
                            dispatch(setUserTokenAction(''))
                            add_msg('帳號密碼錯誤', 'error');
                            history.push('/login')
                            return;
                        }
                        add_msg('登入成功');
                        history.push('/devise_dashboard')
                    })
            }).catch((error) => {
                SystemModal.closeMsg(dispatch)
                fetchExtend.postError(error)
            })
    },
    logout: (dispatch) => {
        if (sessionStorage.getItem('student_token')) {
            sessionStorage.removeItem('student_token');
            setUserTokenAction(dispatch, '');
            history.push('/');
            add_msg('登出成功');
        }
      
        // location.replace('/');
    },
    checkAuth: (dispatch, transfer) => {
        // console.log(sessionStorage.getItem('student_token'))
        fetch(API_SERVER + '/api/student_lists/0.json', {
            credentials: 'same-origin',
            method: 'GET',
            headers: new fetchConfig().fetchConfigHeaders()
        })
            .then(fetchExtend.checkStatus)
            .then(fetchExtend.parseJSON)
            .then((studentList) => {
                if (!canFillApplication(studentList)) {
                    dispatch(logoutAction())
                    add_msg('帳號密碼錯誤', 'error');
                    return;
                }
                if (transfer) {
                    history.push('/devise_dashboard')
                }
            })
            .catch(function (error) {
                if (!transfer) {
                    dispatch(logoutAction())
                }
            });
    }
}



// WEBPACK FOOTER //
// ./src/dashboards_redux/utils/AuthDevise/AuthDevise.jsx